import React from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import LogoWithText from "../assets/images/logowithtext.png";
import "../style/paymentresult.css";

const PaymentFailedPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const orderId = searchParams.get("order_id");

  return (
    <div className="custom-payment-result-page">
      <img src={LogoWithText} alt="Cutting Edge Academy" className="custom-payment-logo" />

      <div className="custom-payment-icon" style={{ backgroundColor: "#fef2f2" }}>
        <i className="bi bi-x-circle-fill" style={{ color: "#dc2626" }}></i>
      </div>

      <h1 className="custom-payment-title">Payment Failed</h1>

      <p className="custom-payment-desc">
        Unfortunately, we couldn't process your payment. No funds have been deducted for this attempt.
      </p>
      <p className="custom-payment-desc">
        Please contact our admin via WhatsApp to request a new payment link, or check your email — you may already have another active link waiting.
      </p>

      {orderId && (
        <div className="custom-payment-detail-box">
          <div className="custom-payment-detail-row">
            <span className="custom-payment-detail-label">Order ID</span>
            <span className="custom-payment-detail-value">{orderId}</span>
          </div>
        </div>
      )}

      <div className="custom-payment-actions" style={{ display: "flex" }}>
        <a
          href="https://wa.me/628984001333"
          target="_blank"
          rel="noopener noreferrer"
          className="custom-payment-btn custom-payment-btn-primary"
        >
          Contact Us via WhatsApp
        </a>
        <button
          className="custom-payment-btn custom-payment-btn-secondary"
          onClick={() => navigate("/")}
          style={{ border: "none", cursor: "pointer" }}
        >
          Back to Homepage
        </button>
      </div>

      <p className="custom-payment-footer">
        &copy; {new Date().getFullYear()} Cutting Edge Academy. All rights reserved.
      </p>
    </div>
  );
};

export default PaymentFailedPage;
